// extracted by mini-css-extract-plugin
export default {"card":"Card-module--card--fde84","main":"Card-module--main--76166","normal":"Card-module--normal--fdd4e"};